<div class="flex flex-column auto-renewal stat-block">
  <span class="stat-block-title">Renewal</span>

  <div class="flex flex-row flex-items-center padding-top-xsmall">
    <div class="stat-block-toggle">
      <mat-slide-toggle *ngIf="!isAutoRenewUpdating" [checked]="autoRenew" (change)="toggleAutoRenew()" [disabled]="isAutoRenewUpdating"></mat-slide-toggle>
      <mat-spinner *ngIf="isAutoRenewUpdating" diameter="30"></mat-spinner>
    </div>
    <div class="flex flex-column">
      <span class="stat-block-value">{{ autoRenew ? 'Automatic' : 'OFF' }}</span>
      <span class="stat-block-desc">
        Your policy will {{ !autoRenew ? 'not ' : ''}} automatically renew {{ !autoRenew ? 'and will expire ' : ''}} on {{ policyDetails.endDate | displayDate }}
      </span>
    </div>
  </div>

  <div class="form-typography padding-top-small" *ngIf="autoRenew">
    <div class="open-form-info is-success padding-medium">
      <p><strong>Your renewal will be automatic</strong></p>
      <span class="text-small">
        We’ll renew your policy automatically, keeping you covered without any gaps. Don’t worry, we will also notify you when your policy is ready for renewal.
      </span>
    </div>
  </div>

  <div class="form-typography padding-top-small" *ngIf="!autoRenew">
    <div class="open-form-info is-warning padding-medium">
      <p><strong>Your renewal has been switched off</strong></p>
      <p class="text-small">Turning your renewal off means your policy will not automatically renew.</p>
      <p class="text-small">Don’t worry, we will notify you when your policy is ready for renewal but ensure you switch this on before the date set out above if you would like to stay insured.</p>
    </div>
  </div>

  <div class="form-typography padding-top-small" *ngIf="showToggleError">
    <div class="open-form-info is-error padding-medium">
      <strong>Oops! Something went wrong.</strong>
      <p class="padding-top-xsmall margin-bottom-none">
        <a mat-button color="primary" (click)="bookAppointment()">Click here</a> to get in touch with us to make this change, or try again later.
      </p>
    </div>
  </div>
</div>
